module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l9X7L"))).then(() => parcelRequire('hEqeo'));